import script from "./SetPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./SetPasswordView.vue?vue&type=style&index=0&id=099f711b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099f711b"]])

export default __exports__